import Cookies from 'js-cookie'

const UserIdKey = 'Web-User-ID'
const MidKey = 'Manufacturer-ID'
export function getUserId() {
  return Cookies.get(UserIdKey)
}

export function setUserId(userId) {
  return Cookies.set(UserIdKey, userId)
}

export function removeUserId() {
  return Cookies.remove(UserIdKey)
}

export function removeCook(key) {
  return Cookies.remove(UserIdKey)
}

//每个页面的页数条件保存进cookie中
export function getCookieByKey(key) {
  return Cookies.get(key)
}
export function setCookieByKey(key,pageSize) {
  return Cookies.set(key, pageSize)
}
export function removeCookieByKey(key) {
  return Cookies.remove(key)
}





// WEBPACK FOOTER //
// ./src/utils/cookie.js